import { render } from "./UserCenter.vue?vue&type=template&id=c74cc646&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=c74cc646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74cc646"]])

export default __exports__